<div class="company-api-key-container container default-padding mat-elevation-z1" fxLayout="column" fxLayoutGap="15px">
  <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'API_KEY.TITLE' | translate }}</h2>
  <hr/>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <span>{{ company.apiKey }}</span>
    <div fxFlex></div>
    <mtn-icon-button (iconButtonClick)="copyApiKeyToClipboard()" [matTooltip]="'API_KEY.COPY_TOOLTIP' | translate">
      <fa-icon icon="copy"></fa-icon>
    </mtn-icon-button>
    <!-- (iconButtonClick)="refresh()" [matTooltip]="'API_KEY.REFRESH_TOOLTIP' | translate" add this into below to start working  -->
    <mtn-icon-button color="accent" *ngIf="hasRefreshPermission" [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
      <fa-icon icon="sync"></fa-icon>
    </mtn-icon-button>
  </div>
</div>
